<template>
  <div class="wrap" id="wrap">
    <Scrollama @step-enter="stepEnterHandler">
      <div class="step1" data-step="a">
        <div class="div-bg step1">
          <img :src="textData.img">
          <div class="big-data_p animation" v-show="show1">
            <div class="title">{{textData.title}}</div>
            <p class="fnt_24">{{textData.describe}}</p>
            <!--        <el-button>-->
            <!--          查看更多-->
            <!--        </el-button>-->
          </div>
        </div>
      </div>
      <div class="tab-wrap">
        <el-radio-group text-color="#0974fd" @input="radioChange" v-model="menuButton">
          <el-radio-button label="first">{{textData.tab1}} <div class="line"></div></el-radio-button>
          <el-radio-button label="second">{{textData.tab2}}<div class="line"></div></el-radio-button>
          <el-radio-button label="third">{{textData.tab3}}<div class="line"></div></el-radio-button>
          <el-radio-button label="fourth">{{textData.tab4}}</el-radio-button>
        </el-radio-group>
      </div>
      <div class="step2" data-step="b">
        <div class="first-wrap" id="first">
          <div v-show="show2">
            <div class="move-title animationToBottom" style="margin-top: 0">
              {{textData.tab1}}
            </div>
            <div class="move-content animation">
              <div class="move-content-item" :style="{ backgroundImage: `url(${item.img})`}" v-for="(item, index) in tab1List" :key="index">
                <div class="fnt-title">{{item.title}}</div>
                <div class="fnt-content">{{item.describe}}</div>
              </div>
            </div>
          </div>
        </div >
      </div>
      <div class="step3" data-step="c">
        <div class="second-wrap" id="second">
          <div  v-show="show3">
            <div class="move-title animationToBottom">
              {{textData.tab2}}
            </div>
            <div class="move-content animation">
              <div class="bg">
                <img :src="tab2Data.img" >
                <div class="core-text">
                  <div>{{tab2Data.title}}</div>
                  <div>{{tab2Data.describe}}</div>
                </div>
                <ul class="fixed" style="padding-inline-start: 0">
                  <li class="wow" :style="{ backgroundImage: `url(${item.img})`}" v-for="(item, index) in tab2List" :key="index">
                    <h3 class="fnt-title">{{item.title}}</h3>
                    <p class="fnt-content">{{item.describe}}</p>
                  </li>
                </ul>
                <!--          <div class="core-left core-fnt">-->
                <!--            敏捷数据服务化-->
                <!--          </div>-->
                <!--          <div class="core-right core-fnt">-->
                <!--            低代码高敏捷-->
                <!--          </div>-->
                <!--          <div class="core-bottom core-fnt">-->
                <!--            智能化资产运营-->
                <!--          </div>-->
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="step4" data-step="d">
        <div class="three-wrap" id="third">
          <div v-show="show4">
            <div class="move-title animationToBottom" style="margin-top: 0">
              {{textData.tab3}}
            </div>
            <div class="move-content animation">
              <el-tabs v-model="activeName" @tab-click="handleClick">
                <el-tab-pane  :name="'tab' + index" v-for="(item, index) in tab3List" :key="index">
                  <div slot="label" class="tab-slot">
                    <img :src="item.icon"/>
                    <div class="fnt-title">{{item.title}}</div>
                  </div>
                  <div class="tab-info">
                    <div class="tab-info-left">
                      <img :src="item.img"/>
                    </div>
                    <div class="tab-info-right">
                      <div class="tab-info-right-child">
                        <div class="fnt-title">{{item.content1}}</div>
                        <div class="fnt-content">{{item.describe1}}</div>
                      </div>
                      <div class="tab-info-right-child">
                        <div class="fnt-title">{{item.content2}}</div>
                        <div class="fnt-content">{{item.describe2}}</div>
                      </div>
                      <div class="tab-info-right-child">
                        <div class="fnt-title">{{item.content3}}</div>
                        <div class="fnt-content">{{item.describe3}}</div>
                      </div>
                      <div class="tab-info-right-child">
                        <div class="fnt-title">{{item.content4}}</div>
                        <div class="fnt-content">{{item.describe4}}</div>
                      </div>
                      <div class="tab-info-right-child">
                        <div class="fnt-title">{{item.content5}}</div>
                        <div class="fnt-content">{{item.describe5}}</div>
                      </div>
                    </div>
                  </div>
                </el-tab-pane>
                <el-tab-pane name="second">
                  <div slot="label" class="tab-slot">
                    <img src="../../../../static/images/productAndService/bigData/tab1.png"/>
                    <div class="fnt-title">配置管理</div>
                  </div>
                  <div class="tab-info">
                    <div class="tab-info-left">
                      <img src="../../../../static/images/productAndService/bigData/tab-left.png"/>
                    </div>
                    <div class="tab-info-right">
                      <div class="tab-info-right-child">
                        <div class="fnt-title">灵活部署</div>
                        <div class="fnt-content">灵活集成其他应用系统，可以介入现有用户认证体系中，实现用户的统一管理。</div>
                      </div>
                      <div class="tab-info-right-child">
                        <div class="fnt-title">在线协作</div>
                        <div class="fnt-content">实现部门内部、部门与部门之间在线文档的协作。</div>
                      </div>
                      <div class="tab-info-right-child">
                        <div class="fnt-title">功能丰富</div>
                        <div class="fnt-content">实现业务系统文档数据的接入，做到文件统一存储和管理。</div>
                      </div>
                      <div class="tab-info-right-child">
                        <div class="fnt-title">能力嵌入</div>
                        <div class="fnt-content">灵活集成其他应用系统，可以接入现有用户认证体系中，实现用户的统一管理。</div>
                      </div>
                      <div class="tab-info-right-child">
                        <div class="fnt-title">统一管理</div>
                        <div class="fnt-content">提供文档校对、摘要生成、内容推荐、统计分析、一键排版、截图取字等功能。</div>
                      </div>
                    </div>
                  </div>
                </el-tab-pane>
                <el-tab-pane name="third">
                  <div slot="label" class="tab-slot">
                    <img src="../../../../static/images/productAndService/bigData/tab1.png"/>
                    <div class="fnt-title">角色管理</div>
                  </div>
                  <div class="tab-info">
                    <div class="tab-info-left">
                      <img src="../../../../static/images/productAndService/bigData/tab-left.png"/>
                    </div>
                    <div class="tab-info-right">
                      <div class="tab-info-right-child">
                        <div class="fnt-title">灵活部署</div>
                        <div class="fnt-content">灵活集成其他应用系统，可以介入现有用户认证体系中，实现用户的统一管理。</div>
                      </div>
                      <div class="tab-info-right-child">
                        <div class="fnt-title">在线协作</div>
                        <div class="fnt-content">实现部门内部、部门与部门之间在线文档的协作。</div>
                      </div>
                      <div class="tab-info-right-child">
                        <div class="fnt-title">功能丰富</div>
                        <div class="fnt-content">实现业务系统文档数据的接入，做到文件统一存储和管理。</div>
                      </div>
                      <div class="tab-info-right-child">
                        <div class="fnt-title">能力嵌入</div>
                        <div class="fnt-content">灵活集成其他应用系统，可以接入现有用户认证体系中，实现用户的统一管理。</div>
                      </div>
                      <div class="tab-info-right-child">
                        <div class="fnt-title">统一管理</div>
                        <div class="fnt-content">提供文档校对、摘要生成、内容推荐、统计分析、一键排版、截图取字等功能。</div>
                      </div>
                    </div>
                  </div>
                </el-tab-pane>
                <el-tab-pane name="fourth">
                  <div slot="label" class="tab-slot">
                    <img src="../../../../static/images/productAndService/bigData/tab1.png"/>
                    <div class="fnt-title">定时任务补偿</div>
                  </div>
                  <div class="tab-info">
                    <div class="tab-info-left">
                      <img src="../../../../static/images/productAndService/bigData/tab-left.png"/>
                    </div>
                    <div class="tab-info-right">
                      <div class="tab-info-right-child">
                        <div class="fnt-title">灵活部署</div>
                        <div class="fnt-content">灵活集成其他应用系统，可以介入现有用户认证体系中，实现用户的统一管理。</div>
                      </div>
                      <div class="tab-info-right-child">
                        <div class="fnt-title">在线协作</div>
                        <div class="fnt-content">实现部门内部、部门与部门之间在线文档的协作。</div>
                      </div>
                      <div class="tab-info-right-child">
                        <div class="fnt-title">功能丰富</div>
                        <div class="fnt-content">实现业务系统文档数据的接入，做到文件统一存储和管理。</div>
                      </div>
                      <div class="tab-info-right-child">
                        <div class="fnt-title">能力嵌入</div>
                        <div class="fnt-content">灵活集成其他应用系统，可以接入现有用户认证体系中，实现用户的统一管理。</div>
                      </div>
                      <div class="tab-info-right-child">
                        <div class="fnt-title">统一管理</div>
                        <div class="fnt-content">提供文档校对、摘要生成、内容推荐、统计分析、一键排版、截图取字等功能。</div>
                      </div>
                    </div>
                  </div>
                </el-tab-pane>
              </el-tabs>
            </div>
          </div>
        </div>
      </div>
      <div class="step5" data-step="e">
        <div class="fourth-wrap" id="fourth">
          <div v-show="show5">
            <div class="move-title animationToBottom" style="margin-top: 0">
              {{textData.tab4}}
            </div>
            <div class="move-content animation">
              <div class="cus-eg">
                <div class="cus-eg-left" v-for="(item, index) in tab4List" :key="index">
                  <div >
                    <img :src='item.img'/>
                  </div>
                  <div class="fnt-title cus-eg-title">{{item.title}}</div>
                  <div class="fnt-content cus-eg-content">{{item.describe}}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="step6" data-step="f">
        <footer-item></footer-item>
      </div>
    </Scrollama>
  </div>
</template>
<script>
import Scrollama from 'vue-scrollama'
import footerItem from '../../components/footer-item'
export default {
  components: {
    Scrollama,
    footerItem
  },
  data () {
    return {
      newsList: [],
      tab1List: [],
      tab2List: [],
      tab3List: [],
      tab4List: [],
      textData: {},
      tab2Data: {},
      menuButton: '',
      offsetY: 0,
      activeName: 'tab0',
      show1: false,
      show2: false,
      show3: false,
      show4: false,
      show5: false
    }
  },
  // mounted () {
  //   if (this.$boss && this.$boss.categories) {
  //     if (this.$boss.categories.news && this.$boss.categories.news.contents) {
  //       this.newsList = this.$boss.categories.news.contents
  //     }
  //   }
  // },

  methods: {
    handleClick () {},
    stepEnterHandler ({element, index, direction}) {
      switch (element.className) {
        case 'step1':
          this.show1 = true
          break
        case 'step2':
          this.show2 = true
          break
        case 'step3':
          this.show3 = true
          break
        case 'step4':
          this.show4 = true
          break
        case 'step5':
          this.show5 = true
          break
      }
    },
    radioChange (label) {
      let selector = '#' + label
      document.querySelector(selector).scrollIntoView({
        behavior: 'smooth'
      })
    },
    detailTo (item) {
    }
  },
  mounted: function () {
    console.log('this.$boss', this.$boss)
    if (this.$boss) {
      this.textData = this.$boss.page201.g201.filter(item => item.link === '大数据服务')[0]
      this.tab1List = [...this.$boss.page211.g211].reverse()
      this.tab2List = [...this.$boss.page221.g221].reverse()
      this.tab2Data = this.$boss.page222.g222[0]
      this.tab3List = [...this.$boss.page231.g231].reverse()
      this.tab4List = [...this.$boss.page241.g241].reverse()
    }
  }
}
</script>
<style scoped lang="less">
  @media screen and (max-width: 1500px){
    .move-title {
      margin-top: 30px;
      position: relative;
      top: 50px;
      width: 100%;
      z-index: 999;
      font-size: 32px;
      color: #323232;
      font-weight: 500;
    }
    .move-content {
      margin-top: 150px;
      position: relative;
      width: 100%;
      height: 50vh;
      z-index: 999;
      display: flex;
      justify-content: space-between;
    }
    .wrap{
      width: 100%;
      height: 100%;
      /*overflow: auto;*/
    }
    .div-bg {
      width: 100%;
      height:70vh;
      /*background: url("../../../../static/images/productAndService/bigData/bg.png") no-repeat;*/
      img {
        width: 100%;
        height: 100%;
      }
      .big-data_p {
        position: relative;
        left: 100px;
        top: -60%;
        color: #fff;
        text-align: left;
        width: calc(100% - 100px);
        z-index: 999;
      }
      .big-data_p .title, .big-data_p p {
        display: -webkit-box;
        overflow: hidden;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
      }
      .big-data_p p {
        font-size: 24px;
      }
      .big-data_p .title {
        width: 100%;
        font-size: 42px;
        font-weight: 400;
        margin-bottom: 15px;
        line-height: 60px;
        max-height: 120px;
      }
      .big-data_p .el-button {
        margin-top: 10vh;
        width: 150px;
        color: #FFFFFF;
        background-color: transparent;
        border: 1px solid #FFFFFF;
        font-size: 16px;
      }
    }
    .tab-wrap {
      position: relative;
      top: -35px;
      width: 90%;
      height: 70px;
      margin-left: 5%;
      background-color: #FFFFFF;
      box-shadow: 0 0 8px 8px rgba(0, 18, 31, 0.07);
      .el-radio-group{
        width: 100%;
        height: 70px;
        .el-radio-button{
          width: 25%;
          height: 70px;
          /deep/ .el-radio-button__inner {
            width: 100%;
            height: 70px;
            line-height: 50px;
            font-size: 20px;
            box-shadow: -1px 0 0 0 transparent;
            background-color: transparent;
            color: #323232;
            border: 1px solid transparent;
          }
        }
      }
      /deep/ .line {
        width: 2px;
        height: 50px;
        border-left: 2px solid #f1f1f1;
        float: right;
      }
    }
    .first-wrap{
      width: 90%;
      margin-left: 5%;
      background: #FFFFFF;
      min-height: 840px;
      .move-content{
        flex-wrap: wrap;
        &-item {
          width: 49%;
          margin-top: 20px;
          min-height: 300px;
          background: url("../../../../static/images/productAndService/bigData/pro1.png") no-repeat;
          background-size: 100% 100%;
          div:first-child {
            padding: 20px 40px 10px;
            text-align: left;
            line-height: 30px;
          }
          div:last-child {
            padding: 0 40px;
            text-align: left;
            line-height: 35px;
          }
        }
      }
    }
    .second-wrap {
      width: 100%;
      height: 1700px;
      background: url("../../../../static/images/productAndService/bigData/core-bg.png") no-repeat;
      background-size: 100% 100%;
      padding-bottom: 50px;
      .move-content {
        /*margin-bottom: 20px;*/
        height: 90vh;
        position: relative;
        .bg {
          margin: 0 auto;
          width: 60%;
          max-width: 613px;
          position: relative;
          height: 607px;
          /*background: url("../../../../static/images/productAndService/bigData/core.png") no-repeat;*/
          /*background-size: 100% 100%;*/
          display: flex;
          justify-content: center;
          align-items: center;
          img {
            vertical-align: top;
            max-width: 100%;
          }
          .core-text {
            position: absolute;
            margin: auto;
            font-size: 42px;
            color: #FFFFFF;
          }
          .core-fnt {
            width: 200px;
            height: 50px;
            text-align: center;
            position: absolute;
            font-size: 24px;
            color: #066fff;
            font-weight: 500;
          }
          /*.core-left{*/
          /*  top: 230px;*/
          /*  left: 613px;*/
          /*  transform: rotate(-70deg);*/
          /*  -webkit-transform: rotate(-70deg);*/
          /*  -ms-transform: rotate(-70deg);*/
          /*  -moz-transform: rotate(-70deg);*/
          /*  -o-transform: rotate(-70deg);*/
          /*}*/
          /*.core-right {*/
          /*  top: 230px;*/
          /*  right: 613px;*/
          /*  transform: rotate(70deg);*/
          /*  -webkit-transform: rotate(70deg);*/
          /*  -ms-transform: rotate(70deg);*/
          /*  -moz-transform: rotate(70deg);*/
          /*  -o-transform: rotate(70deg);*/
          /*}*/
          /*.core-bottom {*/
          /*  top: 470px;*/
          /*}*/
          /*.fixed:before, .clearfix:before, .cf:before, body:before, .header:before, .main:before, .footer:before {*/
          /*  content: '';*/
          /*  display: table;*/
          /*}*/
          /*.fixed:after, .clearfix:after, .cf:after, after, .header:after, .main:after, .footer:after {*/
          /*  content: '';*/
          /*  display: table;*/
          /*  clear: both;*/
          /*}*/
          .fixed {
            position: fixed;
            width: 100%;
            top: 650px;
            left: 5%;
          }
          li {
            /*position: absolute;*/
            list-style-type: none;
            h3 {
              /*font-weight: 500;*/
            }
          }
          .wow:nth-child(1) {
            width: 60%;
            text-align: left;
            padding-left: 24px;
            background: url('../../../../static/images/productAndService/bigData/description.png') left top no-repeat;
          }
          .wow:nth-child(2) {
            width: 60%;
            text-align: left;
            padding-left: 24px;
            background: url('../../../../static/images/productAndService/bigData/description.png') left top no-repeat;
          }
          .wow:nth-child(3) {
            width: 60%;
            text-align: left;
            padding-left: 24px;
            background: url('../../../../static/images/productAndService/bigData/description.png') left top no-repeat;
          }
          .wow:nth-child(4) {
            width: 60%;
            text-align: left;
            padding-left: 24px;
            background: url('../../../../static/images/productAndService/bigData/description.png') left top no-repeat;
          }
          .wow:nth-child(5) {
            width: 60%;
            text-align: left;
            padding-left: 24px;
            background: url('../../../../static/images/productAndService/bigData/description.png') left top no-repeat;
          }
          .wow:nth-child(6) {
            width: 60%;
            text-align: left;
            padding-left: 24px;
            background: url('../../../../static/images/productAndService/bigData/description.png') left top no-repeat;
          }
          .wow:nth-child(7) {
            width: 60%;
            text-align: left;
            padding-left: 24px;
            background: url('../../../../static/images/productAndService/bigData/description.png') left top no-repeat;
          }
        }
      }
    }
    .three-wrap {
      width: 100%;
      min-height: 50vh;
      background: #FFFFFF;
      /*height: 80vh;*/
      .move-content {
        height: auto;
        .el-tabs {
          width: 90%;
          margin-left: 5%;
          /deep/ .el-tabs__nav {
            width: 25%;
          }
          /deep/ .el-tabs__active-bar {
            width: 50% !important;
            left: 25%;
            background-color: #0170fe;
            height: 4px;
          }
          /deep/ .el-tabs__item {
            width: 100%;
            height: 128px;
            /*max-height: 128px;*/
          }
          /deep/.el-tabs__item.is-active {
            color: #0170fe;
          }
        }
      }
      .tab-slot {
        width: 100%;
        display: flex;
        height: 128px;
        position: relative;
        justify-items: center;
        margin: auto;
        img{
          margin-left: 25%;
          width: 70px;
          height: 70px;
        }
        div {
          padding-left: 20px;
          height: 70px;
          line-height: 70px;
          text-align: left;
          width: calc(100% - 70px);
          font-size: 18px;
        }
      }
      .tab-info {
        position: relative;
        display: flex;
        justify-content: space-between;
        &-left {
          width: 50%;
          margin: auto;
          img {
            width: 100%;
          }
        }
        &-right {
          width: 50%;
          &-child {
            margin: 60px 0;
            div {
              text-align: left;
              margin: 15px 0;
            }
            div:first-child {
              padding: 5px 0;
              font-family: "黑体", Helvetica, Arial, sans-serif !important;
              font-weight: bold;
              background: url('../../../../static/images/productAndService/bigData/title-bg.png') left bottom no-repeat;
            }
          }
        }
      }
    }
    .fourth-wrap {
      width: 100%;
      min-height: 70vh;
      background: #f6fbff;
      .move-content {
        height: auto;
        .cus-eg {
          width: 90%;
          margin-left: 5%;
          position: relative;
          display: flex;
          flex-wrap: wrap;
          justify-content: space-between;
          .cus-eg-title {
            padding: 30px 0 10px;
            text-align: left;
            line-height: 30px;
          }
          .cus-eg-content {
            padding: 0 0 30px 0;
            text-align: left;
            line-height: 35px;
          }
          &-left {
            width: 49%;
            img {
              width: 100%;
              height: auto;
            }
          }
          &-right {
            width: 49%;
            img {
              width: 100%;
            }
          }
        }
      }
    }
  }
  @media screen and (min-width: 1501px){
    .move-title {
      margin-top: 30px;
      position: relative;
      top: 50px;
      width: 100%;
      z-index: 999;
      font-size: 32px;
      color: #323232;
      font-weight: 500;
    }
    .move-content {
      margin-top: 150px;
      position: relative;
      width: 100%;
      height: 50vh;
      z-index: 999;
      display: flex;
      justify-content: space-between;
    }
    .wrap{
      width: 100%;
      height: 100%;
      /*overflow: auto;*/
    }
    .div-bg {
      width: 100%;
      height:70vh;
      /*background: url("../../../../static/images/productAndService/bigData/bg.png") no-repeat;*/
      background-size: 100% 100%;
      img {
        width: 100%;
        height: 100%;
        background-size: 100% 100%;
      }
      .big-data_p {
        position: relative;
        left: 100px;
        top: -60%;
        color: #fff;
        text-align: left;
        width: calc(100% - 100px);
        z-index: 999;
      }
      .big-data_p .title, .big-data_p p {
        display: -webkit-box;
        overflow: hidden;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
      }
      .big-data_p p {
        font-size: 24px;
      }
      .big-data_p .title {
        width: 100%;
        font-size: 42px;
        font-weight: 400;
        margin-bottom: 15px;
        line-height: 60px;
        max-height: 120px;
      }
      .big-data_p .el-button {
        margin-top: 10vh;
        width: 150px;
        color: #FFFFFF;
        background-color: transparent;
        border: 1px solid #FFFFFF;
        font-size: 16px;
      }
    }
    .tab-wrap {
      position: relative;
      top: -35px;
      width: 90%;
      height: 70px;
      margin-left: 5%;
      background-color: #FFFFFF;
      box-shadow: 0 0 8px 8px rgba(0, 18, 31, 0.07);
      .el-radio-group{
        width: 100%;
        height: 70px;
        .el-radio-button{
          width: 25%;
          height: 70px;
          /deep/ .el-radio-button__inner {
            width: 100%;
            height: 70px;
            line-height: 50px;
            font-size: 20px;
            box-shadow: -1px 0 0 0 transparent;
            background-color: transparent;
            color: #323232;
            border: 1px solid transparent;
          }
        }
      }
      /deep/ .line {
        width: 2px;
        height: 50px;
        border-left: 2px solid #f1f1f1;
        float: right;
      }
    }
    .first-wrap{
      width: 90%;
      margin-left: 5%;
      background: #FFFFFF;
      height: 60vh;
      .move-content{
        &-item {
          width: 24%;
          height: 46vh;
          background: url("../../../../static/images/productAndService/bigData/pro1.png") no-repeat;
          background-size: 100% 100%;
          div:first-child {
            padding: 50px 40px 10px;
            text-align: left;
            line-height: 30px;
          }
          div:last-child {
            padding: 0 40px;
            text-align: left;
            line-height: 35px;
          }
        }
      }
    }
    .second-wrap {
      width: 100%;
      height: 950px;
      background: url("../../../../static/images/productAndService/bigData/core-bg.png") no-repeat;
      background-size: 100% 100%;
      padding-bottom: 50px;
      .move-content {
        /*margin-bottom: 20px;*/
        height: 90vh;
        position: relative;
        .bg {
          margin: 0 auto;
          width: 60%;
          max-width: 613px;
          position: relative;
          height: 607px;
          /*background: url("../../../../static/images/productAndService/bigData/core.png") no-repeat;*/
          /*background-size: 100% 100%;*/
          display: flex;
          justify-content: center;
          align-items: center;
          img {
            vertical-align: top;
            max-width: 100%;
          }
          .core-text {
            position: absolute;
            margin: auto;
            font-size: 42px;
            color: #FFFFFF;
          }
          .core-fnt {
            width: 200px;
            height: 50px;
            text-align: center;
            position: absolute;
            font-size: 24px;
            color: #066fff;
            font-weight: 500;
          }
          /*.core-left{*/
          /*  top: 230px;*/
          /*  left: 613px;*/
          /*  transform: rotate(-70deg);*/
          /*  -webkit-transform: rotate(-70deg);*/
          /*  -ms-transform: rotate(-70deg);*/
          /*  -moz-transform: rotate(-70deg);*/
          /*  -o-transform: rotate(-70deg);*/
          /*}*/
          /*.core-right {*/
          /*  top: 230px;*/
          /*  right: 613px;*/
          /*  transform: rotate(70deg);*/
          /*  -webkit-transform: rotate(70deg);*/
          /*  -ms-transform: rotate(70deg);*/
          /*  -moz-transform: rotate(70deg);*/
          /*  -o-transform: rotate(70deg);*/
          /*}*/
          /*.core-bottom {*/
          /*  top: 470px;*/
          /*}*/
          /*.fixed:before, .clearfix:before, .cf:before, body:before, .header:before, .main:before, .footer:before {*/
          /*  content: '';*/
          /*  display: table;*/
          /*}*/
          /*.fixed:after, .clearfix:after, .cf:after, after, .header:after, .main:after, .footer:after {*/
          /*  content: '';*/
          /*  display: table;*/
          /*  clear: both;*/
          /*}*/
          li {
            position: absolute;
            list-style-type: none;
            h3 {
              /*font-weight: 500;*/
            }
          }
          .wow:nth-child(1) {
            left: -70%;
            top: 10%;
            width: 60%;
            text-align: right;
            padding-right: 24px;
            background: url('../../../../static/images/productAndService/bigData/description.png') right top no-repeat;
          }
          .wow:nth-child(2) {
            left: -75%;
            top: 50%;
            width: 60%;
            text-align: right;
            padding-right: 24px;
            background: url('../../../../static/images/productAndService/bigData/description.png') right top no-repeat;
          }
          .wow:nth-child(3) {
            left: -50%;
            top: 100%;
            width: 60%;
            text-align: left;
            padding-left: 24px;
            background: url('../../../../static/images/productAndService/bigData/description.png') left top no-repeat;
          }
          .wow:nth-child(4) {
            left: 20%;
            top: 100%;
            width: 60%;
            text-align: left;
            padding-left: 24px;
            background: url('../../../../static/images/productAndService/bigData/description.png') left top no-repeat;
          }
          .wow:nth-child(5) {
            left: 95%;
            top: 100%;
            width: 60%;
            text-align: left;
            padding-left: 24px;
            background: url('../../../../static/images/productAndService/bigData/description.png') left top no-repeat;
          }
          .wow:nth-child(6) {
            left: 110%;
            top: 50%;
            width: 60%;
            text-align: left;
            padding-left: 24px;
            background: url('../../../../static/images/productAndService/bigData/description.png') left top no-repeat;
          }
          .wow:nth-child(7) {
            left: 105%;
            top: 10%;
            width: 60%;
            text-align: left;
            padding-left: 24px;
            background: url('../../../../static/images/productAndService/bigData/description.png') left top no-repeat;
          }
        }
      }
    }
    .three-wrap {
      width: 100%;
      min-height: 50vh;
      background: #FFFFFF;
      /*height: 80vh;*/
      .move-content {
        height: auto;
        .el-tabs {
          width: 90%;
          margin-left: 5%;
          /deep/ .el-tabs__nav {
            width: 25%;
          }
          /deep/ .el-tabs__active-bar {
            width: 50% !important;
            left: 25%;
            background-color: #0170fe;
            height: 4px;
          }
          /deep/ .el-tabs__item {
            width: 100%;
            height: 128px;
            /*max-height: 128px;*/
          }
          /deep/.el-tabs__item.is-active {
            color: #0170fe;
          }
        }
      }
      .tab-slot {
        width: 100%;
        display: flex;
        height: 128px;
        position: relative;
        justify-items: center;
        margin: auto;
        img{
          margin-left: 25%;
          width: 70px;
          height: 70px;
        }
        div {
          padding-left: 20px;
          height: 70px;
          line-height: 70px;
          text-align: left;
          width: calc(100% - 70px);
        }
      }
      .tab-info {
        position: relative;
        display: flex;
        justify-content: space-between;
        &-left {
          width: 50%;
          margin: auto;
          img {
            width: 100%;
          }
        }
        &-right {
          width: 50%;
          &-child {
            margin: 60px 0;
            div {
              text-align: left;
              margin: 15px 0;
            }
            div:first-child {
              padding: 5px 0;
              font-family: "黑体", Helvetica, Arial, sans-serif !important;
              font-weight: bold;
              background: url('../../../../static/images/productAndService/bigData/title-bg.png') left bottom no-repeat;
            }
          }
        }
      }
    }
    .fourth-wrap {
      width: 100%;
      min-height: 70vh;
      background: #f6fbff;
      .move-content {
        height: auto;
        .cus-eg {
          width: 90%;
          margin-left: 5%;
          position: relative;
          display: flex;
          flex-wrap: wrap;
          justify-content: space-between;
          .cus-eg-title {
            padding: 30px 0 10px;
            text-align: left;
            line-height: 30px;
          }
          .cus-eg-content {
            padding: 0 0 30px 0;
            text-align: left;
            line-height: 35px;
          }
          &-left {
            width: 49%;
            img {
              width: 100%;
              height: auto;
            }
          }
          &-right {
            width: 49%;
            img {
              width: 100%;
            }
          }
        }
      }
    }
  }
  .footer-style {
    width: 100%;
    height: 500px;
  }
</style>



// WEBPACK FOOTER //
// src/pages/home/productAndService/bigData/index.vue